import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { HttpClient } from '@angular/common/http'
import { shareReplay } from 'rxjs/operators'

import { environment } from '../../../environments/environment'
import { Environment } from '../interfaces/environment.interface'
/*
 * This service allows to exclude env variables from the bundle for CI reasons.
 * Indeed we need to have exactly the same artifact for different versions (pre-prod, prod...) and this is not the case on Angular builds.
 * That is why we get env variables from a config.json file located at the root of the build
 */
@Injectable({
  providedIn: 'root'
})
export class EnvironmentService {
  private readonly ENV_URL = environment.envFileUrl
  private environment$: Observable<Environment>

  constructor(private http: HttpClient) {}

  public loadEnvironment(): Observable<Environment> {
    if (!this.environment$) {
      this.environment$ = this.http
        .get<Environment>(this.ENV_URL)
        .pipe(shareReplay(1))
    }
    return this.environment$
  }
}
